import React, { useMemo } from "react"
import SubsectionContainer from "../shared/SubsectionContainer"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { FeatureFlag } from "../../../domain/enums/featureFlags"
import ColumnContainer from "../../shared/components/Layout/ColumnContainer"
import Typography, { typographyTypes } from "../../shared/components/Typography"

interface ProvidedCareProps {
  uniqueProvidedCare: string[]
  numberOfProviders: number
}

export const ProvidedCare: React.FC<ProvidedCareProps> = ({
  uniqueProvidedCare,
  numberOfProviders,
}) => {
  const { cms: cmsContent } = useCMSReady([
    "common",
    "provider",
    "publicProfileSlide",
  ])
  const commonText = cmsContent.common
  const providerText = cmsContent.provider
  const publicProfileText = cmsContent.publicProfileSlide

  const isNoVirtualLocationEnabled = useFeatureFlagEnabled(
    FeatureFlag.IsNoVirtualLocationEnabled,
  )

  const sessionTypeTextMap: Record<string, string> = useMemo(() => {
    return {
      inperson: providerText?.sessionsInPerson || "",
      phone: commonText?.phone || "",
      telehealth: providerText?.sessionsTelehealth || "",
    }
  }, [commonText, providerText])

  const providerCareText: string[] = useMemo(() => {
    if (isNoVirtualLocationEnabled) {
      const items: string[] = []
      if (
        uniqueProvidedCare.includes("inperson") &&
        providerText?.sessionsInPerson
      ) {
        items.push(providerText.sessionsInPerson)
      }
      if (
        (uniqueProvidedCare.includes("phone") ||
          uniqueProvidedCare.includes("telehealth")) &&
        commonText?.virtual
      ) {
        items.push(commonText.virtual)
      }
      return items
    }

    const items: string[] = []
    for (const platform of uniqueProvidedCare) {
      if (sessionTypeTextMap[platform]) {
        items.push(sessionTypeTextMap[platform])
      }
    }
    return items
  }, [
    isNoVirtualLocationEnabled,
    uniqueProvidedCare,
    providerText,
    commonText,
    sessionTypeTextMap,
  ])

  let numberOfProvidersText: string | undefined
  if (numberOfProviders === 1) {
    numberOfProvidersText = `${numberOfProviders} ${publicProfileText?.certifiedProvider}`
  } else if (numberOfProviders > 1) {
    numberOfProvidersText = `${numberOfProviders} ${publicProfileText?.certifiedProviders}`
  }

  const handleSort = (unsortedList: string[]) => {
    return unsortedList.sort((a, b) => a.localeCompare(b))
  }
  return (
    <SubsectionContainer>
      <ColumnContainer styleOverrides="space-y-0">
        {handleSort(providerCareText).map((text) => (
          <Typography key={text} text={text} variant={typographyTypes.NORMAL} />
        ))}
        {!!numberOfProvidersText && (
          <Typography
            text={numberOfProvidersText}
            variant={typographyTypes.NORMAL}
          />
        )}
      </ColumnContainer>
    </SubsectionContainer>
  )
}
